import type { IconData } from '@stacksjs/iconify-core'

export const cursor: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M446.754 47.9a20.08 20.08 0 0 0-21.307-2.745L32 229.835v37l165.349 66.139L303.317 496h37L453.281 68.369a20.07 20.07 0 0 0-6.527-20.469m-129.63 410.624l-98.473-151.5l-148.9-59.561L415.779 85.044Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cursor
